/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("dx.webapp.roles").
controller("DxRolesViewRouteController", function RolesViewRouteController(
	$rootScope,
	$location,

	dxSession,
	Node,
	NodeRepository,
	dxAngularConstantHelper,

	dxLocalize
) {
	"use strict";

	var self = this;

	self.DX_ARTICLE_TYPE = dxAngularConstantHelper.DX_ARTICLE_TYPE;

	self.reqs = {
		node: false,
	};

	var nodeId = dxSession.getRole().organizationId;

	if (!nodeId) {
		$rootScope.$broadcast("notification:error", dxLocalize.get("The node you tried to visit doesn't exist."));
		$location.path("/");
		return;
	}


	self.node = new Node();

	NodeRepository.load(nodeId).then(function onNodeLoad(node) {
		self.reqs.node = true;
		self.node = new Node(node);
	});
});
